import axios from "../../axios-auth";
import { pathOr } from "ramda";
import { i18n, PREFIX, addDefaultTranslations } from "../../i18n.js";
import constants from "../../helpers/constants";
import qs from "qs";

const productPartsOptionCode = "product_parts";
const productPartsOptionLabel = i18n.t("Product Parts");

const state = {
  data: {},
  webProductId: 0,
  selectionId: 0,
  activeProductPartCode: "",
  activePageOptions: {},
  isLoading: false,
  numberOfUploads: 0,
  networkError: false,
  networkMessage: "",
  filesNeedToBeConnected: true,
  filesConnectLoading: false,
  numberOfActiveUploads: 0,
  selector: "",
  selectedTemplateId: null,
  theme: ""
};

const getters = {
  getShowAddToCart: state => {
    return state.data.config.isLoggedIn
      ? parseInt(state.data.config.isLoggedIn)
      : 1;
  },
  getTheme: state => {
    return state.theme;
  },
  getPackingUnit: state => {
    return state.data.config.pck_unit &&
      parseInt(state.data.config.pck_unit) > 0
      ? parseInt(state.data.config.pck_unit)
      : 1;
  },
  getHideSearchBoxInPoptext: state => {
    return state.data.config.hide_searchbox_poptext
      ? parseInt(state.data.config.hide_searchbox_poptext)
      : 0;
  },
  getPersonalizationQuantityWithPrice: (state, getters) => {
    if (
      state.data.product_type == "personalization" &&
      state.data.config.quantity_show_price_personalization &&
      getters.getQuantitySelection &&
      getters.getQuantitySelection != ""
    ) {
      return true;
    }
    return false;
  },
  getMeasurementSystem: state => {
    return state.data.config.measuring_system
      ? state.data.config.measuring_system
      : "";
  },
  getShowCostCenter: state => {
    return state.data.config.enable_cost_center
      ? parseInt(state.data.config.enable_cost_center)
      : 0;
  },
  getCostCenterIsRequired: (state, getters) => {
    return getters.getShowCostCenter &&
      state.data.config.enable_cost_center_required
      ? parseInt(state.data.config.enable_cost_center_required)
      : 0;
  },
  getOtherOptionsDenyRules: (state, getters) => {
    var denyRules = Array.isArray(getters.getDenyRules["prod_opts"])
      ? null
      : getters.getDenyRules["prod_opts"];

    return denyRules;
  },
  getPackingTdTextures: state => {
    return state.data.template_config && state.data.template_config.td_data
      ? state.data.template_config.td_data
      : null;
  },

  getSelectedTemplateId: (state, getters) => {
    var activeTemplates = getters.getActiveTemplates;
    return state.selectedTemplateId == null
      ? Object.keys(activeTemplates)[0]
      : state.selectedTemplateId;
  },
  getWebProductEnableTemplateChooser: (state, getters) => {
    var activeTemplates = getters.getActiveTemplates;
    if (
      Object.keys(activeTemplates).length > 1 &&
      state.data.template_chooser &&
      parseInt(state.data.template_chooser) == 0
    ) {
      return true;
    }
    return false;
  },
  getWebProductEnableTemplates: (state, getters) => {
    var templates = [];
    var activeTemplates = getters.getActiveTemplates;
    for (var id in activeTemplates) {
      templates.push({
        id,
        text: activeTemplates[id]
      });
    }

    return templates;
  },
  getWebProductTemplate: (state, getters) => {
    var activeTemplates = getters.getActiveTemplates;
    if (
      state.data.template_chooser &&
      parseInt(state.data.template_chooser) == 1
    ) {
      return Object.keys(activeTemplates);
    }
    if (
      typeof activeTemplates === "object" &&
      Object.keys(activeTemplates).length > 0
    ) {
      return getters.getSelectedTemplateId;
    }
    return pathOr(0, ["data", "template"], state);
  },
  getActiveTemplates: (state, getters) => {
    var changeOptionsTemplate = getters.getChangeOptionsTemplate;
    if (changeOptionsTemplate) {
      return changeOptionsTemplate;
    }
    return pathOr({}, ["data", "template"], state);
  },
  getQuantitySelection: state => {
    return state.data.config.quantity_selection;
  },
  getSelector: state => {
    return state.selector;
  },
  getNumberOfActiveUploads: state => {
    return state.numberOfActiveUploads;
  },
  getFilesConnectLoading: state => {
    return state.filesConnectLoading;
  },
  getConnectFolder: state => {
    return state.selectionId;
  },
  getFilesNeedToBeConnected: state => {
    return state.filesNeedToBeConnected;
  },
  getIsPrintingProduct: state => {
    return state.data.config.printing_product;
  },
  getIsImageEditorProduct: state => {
    return state.data.config.enable_image_editor | 0;
  },
  getIsStockDefaultPDfConfig: state => {
    return state.data.product_type === "stock_configuration_default_pdf";
  },
  getNetworkError: state => {
    return state.networkError;
  },
  getNetworkMessage: state => {
    return state.networkMessage;
  },
  getHasAutomaticConnect: state => {
    if (
      state.data.config.enable_automatic_connect == undefined ||
      state.data.config.enable_automatic_connect == null
    ) {
      return constants.AUTOMATIC_CONNECT_NOT_PRESENT;
    }
    return state.data.config.enable_automatic_connect
      ? constants.AUTOMATIC_CONNECT_TRUE
      : constants.AUTOMATIC_CONNECT_FALSE;
  },
  getNumberOfPP: state => {
    return state.data.productparts.length;
  },
  getIsLfp: state => {
    return state.data.product_type === "image_editor";
  },
  getNumberOfUploads: state => {
    return state.numberOfUploads;
  },
  getLayoutType: state => {
    return state.data.type;
  },
  getConfig: state => {
    return state.data.config;
  },

  getProductName: state => {
    return state.data.name;
  },
  getWebProductData: state => {
    return state.data;
  },

  getActiveProductPartCode: state => {
    return state.activeProductPartCode;
  },
  getWebProductId: state => {
    return state.webProductId;
  },
  getActivePageOptions: state => {
    return state.activePageOptions[state.activeProductPartCode];
  },
  getWebProductName: state => {
    return state.data.name;
  },
  getActiveProductPart: state => {
    if (!state.data.productparts) {
      return [];
    }
    return state.data.productparts.filter(item => {
      return item.code == state.activeProductPartCode;
    });
  },
  getActiveProductPartName: (state, getters) => {
    var activeProductPart = getters.getActiveProductPart;
    return activeProductPart.length > 0 ? activeProductPart[0].label : "";
  },
  getActiveProductPageOptions: (state, getters) => {
    return getters.getAllProductPageOptions(false);
  },
  getAllProductPageOptions: (state, getters, rootState, rootGetters) => all => {
    var allOptions = all ? true : false;
    var activeProductPart = getters.getActiveProductPart;
    var allPageOptions =
      activeProductPart.length > 0 ? activeProductPart[0].page_options : {};
    var options = Object.keys(allPageOptions)
      .filter(item => {
        return allOptions || allPageOptions[item].hidden == 0;
      })
      .reduce((obj, key) => {
        obj[key] = allPageOptions[key];
        return obj;
      }, {});

    /*if (
      !rootGetters.getChangeOptionsDataPPOpt[
        "PP_" + getters.getActiveProductPartCode
      ]
    ) {
      return {}; 
    }*/
    var selectedOpt =
      rootGetters.getChangeOptionsDataPPOpt[
        "PP_" + getters.getActiveProductPartCode
      ];
    var denyRules = Array.isArray(rootGetters.getDenyRules)
      ? null
      : rootGetters.getDenyRules[state.activeProductPartCode];

    if (typeof rootGetters.getDenyRules["global_rule"] !== "undefined")
      denyRules = Object.assign(
        {},
        denyRules,
        rootGetters.getDenyRules["global_rule"]
      );

    var items = {};
    for (var op in options) {
      var item = JSON.parse(JSON.stringify(options[op]));
      item.label = i18n.t(PREFIX.PO + options[op].label);
      for (var value in item.values) {
        item.values[value].label = i18n.t(
          PREFIX.POV + item.values[value].label
        );
      }

      if (denyRules && denyRules[op]) {
        item["values"] = options[op]["values"].filter(el => {
          return !denyRules[op].includes(el.value);
        });
      }
      item["selected"] = selectedOpt[op];
      items[op] = item;
    }
    return items;
  },
  getIsLoading: state => {
    return state.isLoading;
  },
  getSelectionId: state => {
    return state.selectionId;
  },
  getProductPartsNames: state => {
    return state.data.productparts.map(item => {
      return { code: item.code, label: item.label };
    });
  },
  getProductPartsCodes: state => {
    return state.data.productparts.map(item => {
      return item.code;
    });
  },
  getActiveProductOptionsSelection: (
    state,
    getters,
    rootState,
    rootGetters
  ) => {
    //if (state.isLoading) return [];
    var activeProductPart = getters.getActiveProductPart;
    var ppParts = rootGetters.getChangeOptionsDataPPOpt;
    var ppSelection = ppParts["PP_" + activeProductPart[0].code];

    var activePageOption = getters.getActivePageOptions;
    if (!ppSelection[activePageOption]) {
      return [];
    }
    return ppSelection[activePageOption];
  },
  getInitialChangeOptionsPostData: (state, getters, rootState, rootGetters) => {
    var qties = rootGetters.getCustomQuantitiesLabels;

    let postData = {
      webproduct: getters.getWebProductId,
      custom_quantities: qties.length == 0 ? "" : qties
    };
    var data = getters.getWebProductData;
    for (let option in data.options) {
      if (option == "quantity") {
        // set the qty field also
        var default_value = data.options[option].default_value;
        var qty = 1;
        for (var value of data.options[option].values) {
          if (value.value == default_value) {
            qty = value.attributes["qty"];
            break;
          }
        }
        postData["qty"] = qty;
      }
      postData[
        "print_options[" + option + "][" + option + "][]"
      ] = Array.isArray(data.options[option].default_value)
        ? data.options[option].default_value[0]
        : data.options[option].default_value;
    }
    postData["print_options[PP][]"] = getters.getActiveProductPartCode;

    for (let ppKey in data.productparts) {
      var pp = data.productparts[ppKey];
      for (let attribute in pp.page_options) {
        postData[
          "print_options[PP_" + pp.code + "][" + attribute + "][]"
        ] = Array.isArray(pp.page_options[attribute].default_value)
          ? pp.page_options[attribute].default_value[0]
          : pp.page_options[attribute].default_value;
      }
    }

    if (getters.getPersonalizationQuantityWithPrice) {
      var qties = getters.getQuantitySelection.split(",");
      var updatedQty = [];
      for (let qty in qties) {
        updatedQty.push("custom_qty_" + qties[qty]);
      }
      for (let qty in qties) {
        postData["custom_quantities"] = updatedQty;
      }
    }
    return postData;
  },
  getOtherOptions: (state, getters, rootState, rootGetters) => {
    var options = state.data.options;
    var data = [];
    var deniedValues = getters.getOtherOptionsDenyRules;
    for (var option in options) {
      if (options[option].hidden || option == "quantity") {
        continue;
      }
      var allValues = options[option].values;
      if (deniedValues && deniedValues[option]) {
        allValues = options[option].values.filter(el => {
          return !deniedValues[option].includes(el.value);
        });
      }

      var item = {
        type: options[option].type,
        code: option,
        name: i18n.t(PREFIX.PO + options[option].label),
        values: allValues.map(el => {
          return {
            text: i18n.t(PREFIX.POV + el.label),
            id: el.value
          };
        }),
        selected: rootGetters.getChangeOptionsDataPPOpt[option][option] // ????
      };
      data.push(item);
    }
    return data;
  },
  getProductPartsOption: (state, getters) => {
    return {
      multiselect: 0,
      code: productPartsOptionCode,
      name: productPartsOptionLabel,
      values: state.data.productparts.map(el => {
        return {
          text: i18n.t(PREFIX.PP + el.label),
          id: el.code
        };
      }),
      selected: [getters.getActiveProductPartCode]
    };
  },
  getOptions: (state, getters) => {
    var activePPOptions = getters.getActiveProductPageOptions;
    var data = [];
    var item = {};
    // add the product parts if we have more than one
    if (state.data.productparts.length > 1) {
      item = getters.getProductPartsOption;
      data.push(item);
    }

    for (var option in activePPOptions) {
      if (activePPOptions[option].hidden) {
        continue;
      }

      item = {
        multiselect: 0,
        code: option,
        //name: i18n.t(PREFIX.PO + activePPOptions[option].label),
        name: activePPOptions[option].label,
        values: activePPOptions[option].values.map(el => {
          return {
            //text: i18n.t(PREFIX.POV + el.label),
            text: el.label,
            id: el.value
          };
        }),
        selected: activePPOptions[option].selected
      };

      if (option == "format" && getters.getConfig.enable_custom_format) {
        //add custom formats
        if (getters.getConfig.enable_packaging) {
          for (var pack in getters.getPackingCustomFormats) {
            item.values.push({
              text: getters.getPackingCustomFormats[pack].label,
              id: getters.getPackingCustomFormats[pack].value
            });
          }
        } else {
          for (var cust of getters.getCustomFormats) {
            item.values.push({
              text: cust.label,
              id: cust.value
            });
          }
        }
      }

      data.push(item);
    }
    return data;
  },
  getProductPartsOptionCode: state => {
    return productPartsOptionCode;
  },
  getShowPreviewInUpload: state => {
    return true;
  },
  getShouldRenderComponent: state => name => {
    if (
      parseInt(state.data.config.disable_upload) &&
      ["Upload", "UploadButton", "UploadContainer", "UploadTable"].includes(
        name
      )
    ) {
      return false;
    }
    if (
      !parseInt(state.data.config.enable_custom_quantity) &&
      ["InputQuantity"].includes(name)
    ) {
      return false;
    }
    if (
      !parseInt(state.data.config.personalize) &&
      ["PersonalizationButton"].includes(name)
    ) {
      return false;
    }
    if (
      !parseInt(state.data.config.enable_custom_format) &&
      ["InputCustomFormatInsert", "InputCustomFormat"].includes(name)
    ) {
      return false;
    }
    if (
      !parseInt(state.data.config.show_matrix) &&
      [
        "ProductPartsNamesContainer",
        "ProductPartsNames",
        "ProductParts"
      ].includes(name)
    ) {
      return false;
    }

    if (["PackingOptions", "PackingOptionsContainer"].includes(name)) {
      if (
        parseInt(state.data.config.enable_custom_format) &&
        parseInt(state.data.config.enable_packaging)
      ) {
        return true;
      }
      return false;
    }

    return true;
  },
  getPackagingVariables: state => {
    return pathOr([], ["data", "packing_config", "packaging_variables"], state);
  },
  getPackagingModel: state => {
    return pathOr("", ["data", "packing_config", "model"], state);
  },
  getInputUnit: state => {
    return pathOr("mm", ["data", "packing_config", "Input_Unit"], state);
  },
  getIsPackingEnabled: (state, getters) => {
    if (getters.getConfig.enable_packaging) {
      return parseInt(getters.getConfig.enable_packaging) ? true : false;
    }
    return false;
  },
  getEnableLoader: (state, getters) => {
    return getters.getConfig.enable_loader;
  },
  getIsPreflighPitstop: (state, getters) => {
    return (
      getters.getConfig.preflight_enabled &&
      getters.getConfig.preflight_type == "pitstop"
    );
  },
  getIsPersonalizationNewPage: state => {
    return pathOr(1, ["data", "config", "isPersonalizationNewPage"], state);
  },
  getShowConnectButton: (state, getters) => {
    if (getters.getHasAutomaticConnect == constants.AUTOMATIC_CONNECT_TRUE) {
      if (
        getters.getFilesNeedToBeConnected &&
        !getters.getConfig.disable_upload &&
        !getters.getConfig.personalize &&
        getters.getNumberOfPP == getters.getNumberOfUploads
      ) {
        return true;
      }
    }
    return false;
  },
  getIsValidForm: (state, getters) => widget => {
    var valid = true;
    var isPrintingProduct = getters.getIsPrintingProduct;
    var isImageEditorProduct = getters.getIsImageEditorProduct;
    var hasAutomaticConnect = getters.getHasAutomaticConnect;
    var isStockDefaultPDfConfig = getters.getIsStockDefaultPDfConfig;
    var noPP = getters.getNumberOfPP;
    var noUploads = getters.getNumberOfUploads;
    var isLfp = getters.getIsImageEditorProduct;

    if (isPrintingProduct || noPP > 0) {
      if (isPrintingProduct && !isLfp) {
        if (
          hasAutomaticConnect == constants.AUTOMATIC_CONNECT_NOT_PRESENT ||
          hasAutomaticConnect == constants.AUTOMATIC_CONNECT_TRUE
        ) {
          if (
            hasAutomaticConnect == constants.AUTOMATIC_CONNECT_TRUE &&
            getters.getMatrixOneSelection == false
          ) {
            // check that the user made at least one selection in matrix
            if (widget) {
              widget.$swal({
                text: i18n.t("Please configure your product !"),
                icon: "warning"
              });
            }
            return false;
          }
          if (
            noPP !== noUploads &&
            !isImageEditorProduct &&
            !isStockDefaultPDfConfig
          ) {
            valid = false;
            if (widget) {
              widget.$swal({
                text: i18n.t("Please make an upload for each product part!"),
                icon: "warning"
              });
            }
            return false;
          }
        }
      }
    }

    return valid;
  },

  getCallChangeOptionPerType: (state, getters) => {
    if (
      [
        "image_editor",
        "upload_configuration",
        "personalization_configuration",
        "stock_configuration_default_pdf",
        "upload_without_configuration",
        "upload_personalization_configuration",
        "upload_fullpage_configuration",
        "personalization_fullpage_configuration",
        "upload_personalization_configuration_packaging",
        "upload_personalization_fullpage_configuration"
      ].includes(state.data.product_type)
    ) {
      return true;
    }
    if (getters.getPersonalizationQuantityWithPrice) {
      return true;
    }
    return false;
    /*if (
      state.data.config.call_change_options == undefined ||
      state.data.config.call_change_options == null
    ) {
      return false;
    }

    return state.data.config.call_change_options;*/
  }
};

const mutations = {
  setTheme: (state, payload) => {
    state.theme = payload;
  },
  setSelector: (state, payload) => {
    state.selector = payload;
  },
  setFilesConnectLoading: (state, payload) => {
    state.filesConnectLoading = payload;
  },
  setFilesNeedToBeConnected: (state, payload) => {
    state.filesNeedToBeConnected = payload;
  },
  setNetworkError: (state, payload) => {
    if (payload == null) {
      state.networkError = false;
      state.networkMessage = "";
    } else {
      state.networkError = true;
      state.networkMessage =
        i18n.t("Error connecting to server") +
        " : " +
        (payload.message ? payload.message : i18n.t("Network Error"));
    }
  },
  setWebProductData: (state, payload) => {
    state.data = { ...state.data, ...payload };
    state.activeProductPartCode = payload.productparts[0].code;
    var activePageOptions = {};
    for (var key in payload.productparts) {
      var obj = payload.productparts[key];
      var visibleProductParts = Object.keys(obj.page_options).filter(item => {
        return obj.page_options[item].hidden == 0;
      });

      activePageOptions[obj.code] = visibleProductParts[0];
    }
    state.activePageOptions = activePageOptions;
  },
  setActiveProductPageOption: (state, payload) => {
    var activePageOptions = { ...state.activePageOptions };
    activePageOptions[state.activeProductPartCode] = payload;
    state.activePageOptions = activePageOptions;
  },
  setActiveProductPartName: (state, payload) => {
    state.activeProductPartCode = payload;
  },
  setIsLoading: (state, payload) => {
    state.isLoading = payload;
  },
  setWebProductId: (state, payload) => {
    state.webProductId = payload;
  },
  setSelectionId: (state, payload) => {
    state.selectionId = payload;
  },
  uploadFile: state => {
    state.numberOfUploads++;
  },
  removeUploadedFile: state => {
    state.numberOfUploads--;
  },
  uploadLoading: (state, payload) => {
    if (payload) {
      state.numberOfActiveUploads++;
    } else {
      state.numberOfActiveUploads--;
    }
  },
  setSelectedTemplateId: (state, payload) => {
    state.selectedTemplateId = payload;
  }
};

const actions = {
  connectUploads: ({ commit, getters }, payload) => {
    commit("setFilesConnectLoading", true);

    axios.instance
      .post(
        getters.getUrl(axios.connectUpload),
        qs.stringify({ path: getters.getConnectFolder, selection: 1 })
      )
      .then(response => {
        if (response.data && response.data.msg == "success") {
          // files connected
          commit("setFilesNeedToBeConnected", false);
          commit("setDisableDeleteUploadAfterConnect", true);
        } else if (response.data && response.data.msg == "err") {
          // files connected
          payload.widget.$swal({
            text: "Error " + response.data.additional,
            icon: "error"
          });
        }
        commit("setFilesConnectLoading", false);
      })
      .catch(error => {
        commit("setFilesConnectLoading", false);
        console.log("Error " + error);
        payload.widget.$swal({
          text: "Error " + error,
          icon: "error"
        });
      });
  },
  setFilesNeedToBeConnected: ({ commit }, payload) => {
    commit("setFilesNeedToBeConnected", payload);
  },
  setNetworkError: ({ commit }, payload) => {
    commit("setNetworkError", payload);
  },
  setWebProductData: ({ commit }, payload) => {
    commit("setWebProductData", payload);
  },
  setActiveProductPageOption: ({ commit }, payload) => {
    commit("setActiveProductPageOption", payload);
  },
  setActiveProductPartName: ({ commit, dispatch }, payload) => {
    commit("setActiveProductPartName", payload);
    dispatch("setShowUpload", false);
  },
  setIsLoading: ({ commit }, payload) => {
    commit("setIsLoading", payload);
  },
  setSelectedTemplateId: ({ commit }, payload) => {
    commit("setSelectedTemplateId", payload);
  },
  uploadFile: ({ commit, getters, dispatch }, payload) => {
    commit("uploadFile");
    dispatch("setPersonalizationFullPage", false);
    if (getters.getNumberOfUploads == getters.getNumberOfPP) {
      dispatch("setAddToCartFullPage", true);
    }
  },
  removeUploadedFile: ({ commit, getters, dispatch }, payload) => {
    commit("removeUploadedFile");
    if (getters.getNumberOfUploads == 0) {
      dispatch("setPersonalizationFullPage", true);
    }
    dispatch("setAddToCartFullPage", false);
  },
  uploadLoading: ({ commit }, payload) => {
    commit("uploadLoading", payload);
  },
  loadInitialData: ({ commit, getters, dispatch }, payload) => {
    commit("setWebProductId", payload.webProductId);
    commit("setSelectionId", payload.selectionId);

    if (payload.theme) {
      commit("setTheme", payload.theme);
    }
    if (payload.urls) {
      dispatch("setUrls", payload.urls);
    }
    if (payload.customer) {
      dispatch("setCustomer", payload.customer);
    }
    if (payload.isLogin) {
      dispatch("setIslogin", payload.isLogin);
    }
    if (payload.beforeChangeOptionsCallback) {
      dispatch(
        "setBeforeChangeOptionCallback",
        payload.beforeChangeOptionsCallback
      );
    }
    if (payload.beforePersonalizeCallback) {
      dispatch(
        "setBeforePersonalizeCallback",
        payload.beforePersonalizeCallback
      );
    }
    if (payload.photoMappingCallback) {
      dispatch("setPhotoMappingCallback", payload.photoMappingCallback);
    }

    if (payload.onCartSubmitCallback) {
      commit("registerOnCartSubmitCallback", payload.onCartSubmitCallback);
    }
    commit("setSelector", payload.selector);

    commit("setNetworkError", null);
    if (payload.isMyAccount) {
      dispatch("setCallChangeOptions", false);
      dispatch("setMyAccount", {
        isMyAccount: payload.isMyAccount,
        myAccountSelection: payload.myAccountSelection,
        myAccountUploadedFiles: payload.myAccountUploadedFiles,
        toggleReadyToConnect: payload.toggleReadyToConnect,
        orderItemId: payload.orderItemId,
        myAccountUploadPath: payload.myAccountUploadPath
      });
    }

    if (payload.initialConfig) {
      commit("setWebProductData", payload.initialConfig);
      afterInitialConfigData(dispatch, getters, payload.initialConfig);
      return;
    }

    var url = getters.getUrl(axios.apiGetConfig) + getters.getWebProductId;
    if (payload.getConfigTokenData) {
      url = getters.getUrl(axios.apiGet) + "?jwt=" + payload.getConfigTokenData;
    }

    axios.instance
      .get(url)
      .then(response => {
        commit("setWebProductData", response.data);
        afterInitialConfigData(dispatch, getters, response.data);
      })
      .catch(error => {
        console.log("Error " + error);
        commit("setIsLoading", false);
        commit("setNetworkError", error);
      });
  },
  setChangeOptionsTemplate: ({ commit, getters, dispatch }, payload) => {
    var templateIds = Object.keys(getters.getActiveTemplates);
    if (templateIds.length) {
      if (!templateIds.includes(getters.getSelectedTemplateId)) {
        commit("setSelectedTemplateId", templateIds[0]);
      }
    }
  }
};

const afterInitialConfigData = (dispatch, getters, initialData) => {
  window.printqMatrixConfig = getters.getWebProductData;
  if (initialData && initialData.image_editor) {
    dispatch("loadImageEditorData", initialData.image_editor);
  }
  dispatch("loadCustomFromLocalStorage");
  dispatch("changeOptions", { initialLoading: 1 });

  addDefaultTranslations(
    getters.getWebProductData.options,
    getters.getWebProductData.productparts
  );
};

export default {
  state,
  getters,
  mutations,
  actions
};
